import { GameFrame } from '@/features/game-client/game-frame';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { FgpAwagerLaunchData } from '@/features/providers/awager/types';
import { GameDataProp } from '@/features/providers/types';
import { useAppSelector } from '@/store/hooks';

export const Awager: React.FC<GameDataProp> = ({ data }: GameDataProp) => {
  const { url } = (data as FgpAwagerLaunchData).launchDetails;
  const { gameName } = useAppSelector(gameContextSelector);

  return <GameFrame url={url} title={gameName} />;
};
